import React, { useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import FaIcon from "../fa-icon/fa-icon";
import IconEnum from "../../enums/icon.enum";
import { AlertToastProps } from "./alert-toast.props";
import "./alert-toast.scss";
import { IconLibraryEnum, PriorityEnum } from "../../wne-mpng-components-mf";

const AlertToast = (props: AlertToastProps) => {
  const { priority, message, dismissible = true, timeout = 3000, show, onClose } = props;
  const [showAlert, setShowAlert] = useState(false);
  const timeoutRef = useRef(null);

  const handleClose = () => {
    setShowAlert(false);
    onClose();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    if (show) {
      setShowAlert(true);
      timeoutRef.current = setTimeout(() => {
        setShowAlert(false);
        onClose();
      }, timeout);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [onClose, show, timeout]);

  const getPriorityIcon = () => {
    switch (priority) {
      case PriorityEnum.SUCCESS:
        return IconEnum.CIRCLE_CHECK;
      case PriorityEnum.WARNING:
        return IconEnum.CIRCLE_EXCLAMATION;
      case PriorityEnum.INFO:
        return IconEnum.CIRCLE_INFO;
      default:
        return IconEnum.CIRCLE_INFO;
    }
  };

  return (
    <Alert
      className="alert-toast-container"
      show={showAlert}
      style={priority === PriorityEnum.WARNING ? { backgroundColor: "#e25546" } : {}}
    >
      {priority && <FaIcon className="alert-toast-icon" icon={getPriorityIcon()} library={IconLibraryEnum.REGULAR} />}
      <span>{message}</span>
      {dismissible && (
        <button className="alert-toast-close-button" onClick={() => handleClose()}>
          <FaIcon className="alert-toast-close-icon" icon={IconEnum.XMARK} />
        </button>
      )}
    </Alert>
  );
};

export default AlertToast;
